<template>
    <div
        class="accounting-year-status-label"
        :class="{
            'processing': value === 0,
            'settlementting': value === 1,
            'closed': value === 2,
        }"
    ><i class="el-icon-lock" v-if="locked"></i> {{ statusName }}</div>
</template>
<script>
import { accountYearStatus } from '@/assets/commonData/options';

export default {
    name: 'AccountingYearlyManagement',
    props: {
        value: {
            type: Number,
            default: () => null,
        },
        locked: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            accountYearStatus,
        };
    },
    computed: {
        statusName() {
            if (this.value === null) return '';

            const status = this.accountYearStatus.find((s) => s.key === this.value);
            if (!status) return '---';
            return status.label;
        },
    },
    methods: {
    },
};
</script>
<style lang="scss">
.accounting-year-status-label {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    padding: 0 12px;
    border-radius: 13px;
    background-color: #eee;
    white-space: nowrap;
    font-size: 9.5pt;
    font-weight: 500;

    &.settlementting {
        background-color: #ffe36c;
        color: #4d2c06;
    }

    &.processing {
        background-color: #463cb2;
        color: #fff;
    }

    // &.to-be-pass {
    //     background-color: #dae0ff;
    //     color: #1f3190;
    // }

    &.closed {
        background-color: #def5d6;
        color: #0baa1b;
    }
}
</style>
